import { format } from "date-fns";

const PICKUP_TIME_WINDOW_LABELS = {
  morning: "Morning (8:00 - 12:00)",
  midday: "Midday (12:00 - 14:00)",
  afternoon: "Afternoon (14:00 - 18:00)",
  flexible: "Flexible",
  fixed: "Fixed",
};

export const formatPickupTimeWindow = (timeWindow) => {
  if (!timeWindow) return null;
  if (typeof timeWindow === "string") {
    return PICKUP_TIME_WINDOW_LABELS[timeWindow] || timeWindow;
  }
  if (timeWindow.start && timeWindow.end) {
    return `${timeWindow.start} - ${timeWindow.end}`;
  }
  if (timeWindow.type) {
    return PICKUP_TIME_WINDOW_LABELS[timeWindow.type] || timeWindow.type;
  }
  return null;
};

export const formatPickupTime = (booking) => {
  if (!booking) return null;
  const datePart = booking.moveDate
    ? format(new Date(booking.moveDate), "PPP")
    : null;
  const timePart = formatPickupTimeWindow(booking.pickupTimeWindow);
  if (datePart && timePart) return `${datePart} • ${timePart}`;
  return datePart || timePart || null;
};

export const formatPickupDate = (moveDate) => {
  if (!moveDate) return null;
  return format(new Date(moveDate), "PPP");
};
